import useAccess from "../../authorization/hooks/useAccess.js";
import { COMPANY_SECTION_MODULES, COMPANY_SECTION_CAPABILITIES } from "../../authorization/companySectionFeatures.js";
import HelpSupport from "./clients-account-comps/account/HelpSupport.jsx";
import useFeature from "../../authorization/hooks/useFeature.js";
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { serverHost } from "../../http_common.js"; 
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import "./companyAccount.css";
import "./companyAccount.rwd.css";
import ClientMobileNavigation, { ClientMobileTopbar } from "./client-mobile-navigation/ClientMobileNavigation.jsx";
import { useDispatch } from "react-redux";
import * as Action from "../../store/redux/client_reducer.js";
import { isCompanySectionAllowed, canOpenPOS } from "../../authorization/companyUserAccess.js";
import * as Actionterminal from "../../store/redux/terminal_reducer.js";
import { productsData } from "./clients-account-comps/data.js";
import IsLoading from "../../IsLoading.jsx";

//////////////////////////////////////////////////////////////////

/// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "./styles.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/scrollbar";
import UniLogo from "./client_account_images/universe.png";
// Import required modules
import { FreeMode, Scrollbar, Mousewheel } from "swiper/modules";
// importing components
import ClientsDashboard from "./clients-account-comps/ClientsDashboard.jsx";
// Icons import
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
import DiscountIcon from "@mui/icons-material/Discount";
import PanToolIcon from "@mui/icons-material/PanTool";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import VideoLibraryRoundedIcon from "@mui/icons-material/VideoLibraryRounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import HelpCenterRoundedIcon from "@mui/icons-material/HelpCenterRounded";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
// ________________________________________________________________________________________________
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import Sales from "./clients-account-comps/inventory_comps/Sales.jsx";
import Quotation from "./clients-account-comps/inventory_comps/Quotation.jsx";
import Discount from "./clients-account-comps/inventory_comps/Discount.jsx";
import Subscriptions from "./clients-account-comps/inventory_comps/Subscriptions.jsx";
import Drafts from "./clients-account-comps/inventory_comps/Drafts.jsx";
import SellReturn from "./clients-account-comps/inventory_comps/SellReturn.jsx";
import ProductServices from "./clients-account-comps/inventory_comps/ProductServices.jsx";
import Imports from "./clients-account-comps/inventory_comps/Imports.jsx";
import PriceGroups from "./clients-account-comps/inventory_comps/PriceGroups.jsx";
import Units from "./clients-account-comps/inventory_comps/Units.jsx";
import Brands from "./clients-account-comps/inventory_comps/Brands.jsx";
import PointOfSaleSharpIcon from "@mui/icons-material/PointOfSaleSharp";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ShareIcon from "@mui/icons-material/Share";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import BookmarksOutlinedIcon from "@mui/icons-material/BookmarksOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import Categories from "./clients-account-comps/inventory_comps/Categories.jsx";
import TaxRate from "./clients-account-comps/inventory_comps/TaxRate.jsx";
import Variations from "./clients-account-comps/inventory_comps/Variations.jsx";
import Recives from "./clients-account-comps/inventory_comps/Recieves.jsx";
import Returns from "./clients-account-comps/inventory_comps/Returns.jsx";
import FilterOrders from "./clients-account-comps/inventory_comps/filters/FilterOders.jsx";
import Orders from "./clients-account-comps/inventory_comps/Orders.jsx";
import Transfers from "./clients-account-comps/inventory_comps/Transfers.jsx";
import OpeningStock from "./clients-account-comps/inventory_comps/OpeningStock.jsx";
import Reconciliation from "./clients-account-comps/inventory_comps/Reconciliation.jsx";
import FilterAdjustment from "./clients-account-comps/inventory_comps/filters/FilterAdjustment.jsx";
import Adjustment from "./clients-account-comps/inventory_comps/Adjustment.jsx";
import Expenses from "./clients-account-comps/inventory_comps/Expenses.jsx";
import ExpenseCategory from "./clients-account-comps/inventory_comps/ExpenseCategory.jsx";
import Invoicing from "./clients-account-comps/inventory_comps/Invoicing.jsx";
import Production from "./clients-account-comps/inventory_comps/Production.jsx";
import ReportsMain from "./clients-account-comps/reports_comps/ReportsMain.jsx";
import Services from "./clients-account-comps/inventory_comps/Services.jsx";
import Delivery from "./clients-account-comps/inventory_comps/Delivery.jsx";
import Profile from "./clients-account-comps/account/Profile.jsx";
import Setting from "./clients-account-comps/account/Setting.jsx";
import Users from "./clients-account-comps/account/Users.jsx";
import Language from "./clients-account-comps/account/Language.jsx";
import AlertBar from "../../AlertBar.jsx";
import PurchaseOrders from "./purchases/PurchaseOrders.jsx";
import PlansBilled from "../universe-company-directrory/PlansBilled.jsx";
import SubscriptionRestriction from "../universe-company-directrory/SubscriptionRestriction.jsx";
import useSubscriptionAccess from "../../authorization/hooks/useSubscriptionAccess.js";
import { isSubscriptionSectionRestricted } from "../../authorization/subscriptionAccess.js";
import "../universe-company-directrory/subscriptionAccess.css";
import CompaniesItemsData from "./clients-account-comps/inventory_comps/CompaniesItemsData.jsx";
import PreviewItem from "./clients-account-comps/inventory_comps/previews/PreviewItem.jsx";
import EditItem from "./clients-account-comps/inventory_comps/edits/EditItem.jsx";
import PurchaseOrdersPreview from "./clients-account-comps/inventory_comps/previews/PreviewPurchseOrders.jsx";
import AddNewItem from "./clients-account-comps/inventory_comps/create/AddNewItem.jsx";

export default function CompanyAccount() {
  const access = useAccess();
  const [accessNotice, setAccessNotice] = useState("");
  const sectionPlanDecision = (hook) => {
    const module = COMPANY_SECTION_MODULES[hook];
    const capability = COMPANY_SECTION_CAPABILITIES[hook];
    return module
      ? { allowed: access.subscription.active && access.hasModule(module) && (!capability || access.hasCapability(capability)), reason: "subscription" }
      : { allowed: true };
  };
  // ```````````````````````````````````````````````````````````````````````````````````````````````
  //              Universe Inventory Features Access Control
  const { hasFeature, hasAllFeatures, hasAnyFeature } = useFeature();
  const subscriptionAccess = useSubscriptionAccess(); // ```````````````````````````
  // ```````````````````````````````````````````````````````````````````````````````````````````````
  const [searchParams, setSearchParams] = useSearchParams();
  const { accessType } = useSelector((state) => state.clientFunction);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const mobileMenuTriggerRef = useRef(null);
  const closeMobileNavigation = useCallback(() => setIsMobileNavOpen(false), []);

  useEffect(() => {
    const media = window.matchMedia("(min-width: 769px)");
    const closeOnDesktop = (event) => {
      if (event.matches) setIsMobileNavOpen(false);
    };
    media.addEventListener?.("change", closeOnDesktop);
    return () => media.removeEventListener?.("change", closeOnDesktop);
  }, []);
  const [showModal, setShowModal] = useState("");
  const [openModalBill, setOpenModalBill] = useState(false);
  const [dismissedBannerKey, setDismissedBannerKey] = useState(null);
  const [requestedArea, setRequestedArea] = useState("");

  // REDUX DATA FUNCTION
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { staffData, accessFeatures } = useSelector(
    (state) => state.clientFunction?.companiesDB,
  );
  const active_title = useSelector(
    (state) => state.clientFunction?.dashboard?.nav_title,
  );
  const active = useSelector(
    (state) => state.clientFunction?.dashboard?.nav_trace,
  );
  const active_display_title = useSelector(
    (state) => state.clientFunction?.dashboard?.subNavBar_title,
  );
  const active_display = useSelector(
    (state) => state.clientFunction?.dashboard?.subNavBar_trace,
  );
  const openIndex = useSelector(
    (state) => state.clientFunction?.dashboard?.toggleNavDropdown,
  );
  const currentTab = useSelector(
    (state) => state.clientFunction?.dashboard?.toggleNavDropdown,
  );
  const cart = useSelector((state) => state.terminalActions.warehouse?.cart);
  // const [active, setActive] = useState("done");
  let terminalWindow = null;

  function logOut() {
    dispatch(Action.logOut());
    dispatch(Actionterminal.onlogOutTerminalAction());
    // navigate("/client_login");
  }

  // Redux functions for dashboards navigation
  function handleNavigator(item, index, type) {
    setRequestedArea("");
    if (accessType === "USER_ACCESS" &&
      !(item?.children?.some(child => isCompanySectionAllowed(accessType, staffData, child.hook)) ||
        isCompanySectionAllowed(accessType, staffData, item?.hooks))) return;
    const active = item?.active;
    const title = item?.title;
    const hooks = item?.hooks;
    const main = item?.hooks;
    const children = item?.children;
    dispatch(
      Action.dispathcDashboardNavigator({
        active,
        title,
        hooks,
        main,
        children,
      }),
    );
    if (openIndex == index) {
      dispatch(DispatchOpenIndex(""));
      return;
    } else {
      dispatch(DispatchOpenIndex(index));
    }

    if (type === "DIRECT_BUTTON_ACTION") {
      setIsMobileNavOpen(false);
    }
  }

  // Mobile submenu selections update the same Redux navigation state as desktop.
  // Unlike an accordion-only tap, this selects the parent as well as the page.
  function handleMobileSubNavigator(item, child, index) {
    dispatch(
      Action.dispathcDashboardNavigator({
        active: item.active,
        title: item.title,
        hooks: item.hooks,
        main: item.hooks,
        children: item.children,
      }),
    );
    dispatch(DispatchOpenIndex(index));
    handleSubNavigator(child.hook, child.title, item.title, child.link);
  }

  function toggleModalBoxContents() {
    return <PlansBilled onClose={() => setOpenModalBill(false)} />;
  }
  // Redux functions for sub-navigation
  function handleSubNavigator(hook, title, main, link) {
    if (!subscriptionAccess.active && isSubscriptionSectionRestricted(hook)) {
      setRequestedArea(title || "this feature");
      setIsMobileNavOpen(false);
      return;
    }
    setRequestedArea("");
    const planDecision = sectionPlanDecision(hook);
    if (!planDecision.allowed) {
      setAccessNotice(access.message(planDecision, title || hook));
      return;
    }
    if (!isCompanySectionAllowed(accessType, staffData, hook)) {
      setAccessNotice("You do not have permission to access this section. Contact your company administrator.");
      return;
    }
    setAccessNotice("");
    if (link) {
      navigate(link);
    } else {
      dispatch(Action.dispatchDashboardSubNavigator({ hook, title, main }));
    }
    setIsMobileNavOpen(false);
  }

  // -------------------------- AXIOS CRUD --------------------
  function apiFetchItems() {
    if (!subscriptionAccess.active) { setRequestedArea("Point of Sale"); return; }
    if (!canOpenPOS(accessType, staffData)) return;
    window.open(
      `${window.location.origin}/clients/workspace/terminal-login`,
      "_blank",
    );
  }
  // -----------------------------------------------------=====
  const breads = { active, active_display, active_title, active_display_title };
  function switchComponents() {
    if (!subscriptionAccess.active && (isSubscriptionSectionRestricted(active_display) || requestedArea)) {
      return <SubscriptionRestriction area={requestedArea || active_display_title || "business operations"} />;
    }
    const planDecision = sectionPlanDecision(active_display || "dashboard");
    if (!planDecision.allowed) {
      return <div className="pd4 fs3" role="status">{access.message(planDecision, active_display_title || "This feature")}</div>;
    }
    if (!isCompanySectionAllowed(accessType, staffData, active_display || "dashboard")) {
      return <div className="pd4 fs3">You do not have permission to view this company section.</div>;
    }
    switch (active_display) {
      case "profile":
        return <Profile />;
      case "dashboard":
        return (
          <ClientsDashboard
            handleSubNavigator={handleSubNavigator}
            data={companyData}
            loading={loading}
            setLoading={setLoading}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "sales":
        return (
          <Sales
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "quatations":
        return (
          <Quotation
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "discount":
        return (
          <Discount
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "subscriptions":
        return (
          <Subscriptions
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "draft":
        return (
          <Drafts
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "items":
        return (
          <CompaniesItemsData
            handleNavigator={handleNavigator}
            handleSubNavigator={handleSubNavigator}
            data={companyData}
            breadcrumbs={breads}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "item-explore-display":
        return (
          <PreviewItem
            handleSubNavigator={handleSubNavigator}
            data={companyData}
          />
        );
      case "add-new-item":
        return (
          <AddNewItem
            onCancel={() => handleSubNavigator("items", "Items", "Items")}
            data={companyData}
          />
        );
      case "edit-item-display":
        return (
          <EditItem
            companyData={companyData}
            onCancel={() =>
              handleSubNavigator(
                "item-explore-display",
                "Item Preview",
                "Item Preview",
              )
            }
            setLoading={setLoading}
            setAlert={setAlert}
          />
        );
      case "services":
        return (
          <Services
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "product_services":
        return (
          <ProductServices
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "imports":
        return (
          <Imports
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "price_groups":
        return (
          <PriceGroups
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "units":
        return (
          <Units
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "brands":
        return (
          <Brands
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "categories":
        return (
          <Categories
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "taxrate":
        return (
          <TaxRate
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "variations":
        return (
          <Variations
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "recieves":
        return (
          <Recives
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "returns":
        return (
          <Returns
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "sell_return":
        return (
          <SellReturn
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "orders":
        return (
          <Orders
            breadcrumbs={breads}
            data={companyData}
            dispatchPageRender={handleSubNavigator}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "transfers":
        return (
          <Transfers
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "openingstock":
        return (
          <OpeningStock
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "reconciliation":
        return (
          <Reconciliation
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "adjusment":
        return (
          <Adjustment
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "deliveries":
        return (
          <Delivery
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "expenses":
        return (
          <Expenses
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "expense_category":
        return (
          <ExpenseCategory
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "invoicing":
        return (
          <Invoicing
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "production":
        return (
          <Production
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      case "reports_main":
        return (
          <ReportsMain
            breadcrumbs={breads}
            data={companyData}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
      // /.....................................
      case "faqs":
      case "contact-support":
      case "system-guide":return <HelpSupport section={showModal} onNavigate={handleSubNavigator}/>;
      case "setting":
        return <Setting />;
      case "users":
      case "Staff":
        return <Users />;
      case "language":
        return <Language />;
      case "place-new-order":
        return <PurchaseOrders onSaved={() => handleSubNavigator("orders")} onCancel={() => handleSubNavigator("orders")} />;
      case "purchase-order-preview":
        return <PurchaseOrdersPreview />;
      default:
        return (
          <ClientsDashboard
            handleSubNavigator={handleSubNavigator}
            data={companyData}
            loading={loading}
            setLoading={setLoading}
            setIsMobileNavOpen={setIsMobileNavOpen}
          />
        );
    }
  }

  // FUNCTION FOR SIDE NAVIGATION BAR ACCORDION

  const DispatchOpenIndex = (index) => async (dispatch) => {
    try {
      dispatch(Action.dispatchClientOpenIndex({ index }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };

  const allMenuItems = [
    {
      title: "Dashboard",
      icon: <DashboardRoundedIcon fontSize="medium" />,
      hooks: "dashboard",
      active: "dashboard",
    },
    {
      title: "Transactions",
      icon: <VideoLibraryRoundedIcon fontSize="medium" />,
      hooks: "transactions",
      active: "transactions",
      children: [
        {
          title: "Sales",
          hook: "sales",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Quotation",
          hook: "quatations",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Discount",
          hook: "discount",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Subscriptions",
          hook: "subscriptions",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Draft",
          hook: "draft",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Sell Return",
          hook: "sell_return",
          tabs: ["main", "completed", "pending"],
        },
      ],
    },
    {
      title: "Manage Items",
      icon: <MenuBookRoundedIcon fontSize="medium" />,
      hooks: "manage_products",
      active: "manage_products",
      children: [
        {
          title: "All Items",
          hook: "items",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Add New Item",
          hook: "add-new-item",
        },
        {
          title: "Imports",
          hook: "imports",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Price Groups",
          hook: "price_groups",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Units",
          hook: "units",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Brands",
          hook: "brands",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Categories",
          hook: "categories",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Tax Setup",
          hook: "taxrate",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Variations",
          hook: "variations",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Services",
          hook: "services",
          tabs: ["main", "completed", "pending"],
        },
      ],
    },
    {
      title: "Purchases",
      icon: <EventRoundedIcon fontSize="medium" />,
      hooks: "purchases",
      active: "purchases",
      children: [
        {
          title: "Orders",
          hook: "orders",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Recieves",
          hook: "recieves",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Returns",
          hook: "returns",
          tabs: ["main", "completed", "pending"],
        },
      ],
    },
    {
      title: "Manage Stock",
      icon: <InsightsRoundedIcon fontSize="medium" />,
      hooks: "performance",
      active: "performance",
      children: [
        {
          title: "Delivery",
          hook: "deliveries",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Transfers",
          hook: "transfers",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Opening Stock",
          hook: "openingstock",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Reconciliation",
          hook: "reconciliation",
          tabs: ["main", "completed", "pending"],
        },

        {
          title: "Adjusment",
          hook: "adjusment",
          tabs: ["main", "completed", "pending"],
        },
        {
          title: "Services",
          hook: "product_services",
          tabs: ["main", "completed", "pending"],
        },
      ],
    },
    {
      title: "Expense",
      icon: <ForumRoundedIcon fontSize="medium" />,
      hooks: "expenses",
      active: "expenses",
      // children: [
      //   {
      //     title: "Expenses",
      //     hook: "expenses",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Categories",
      //     hook: "expense_category",
      //     tabs: ["main", "completed", "pending"],
      //   },
      // ],
    },
    {
      title: "Invoicing",
      icon: <EventRoundedIcon fontSize="medium" />,
      hooks: "invoicing",
      active: "invoicing",
    },
    {
      title: "Production",
      icon: <WorkspacePremiumRoundedIcon fontSize="medium" />,
      hooks: "production",
      active: "production",
      // children: [
      //   {
      //     title: "Recipe",
      //     hook: "recipe",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Production",
      //     hook: "production",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Settings",
      //     hook: "settings",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Report",
      //     hook: "report",
      //     tabs: ["main", "completed", "pending"],
      //   },
      // ],
    },
    {
      title: "Reports",
      icon: <WorkspacePremiumRoundedIcon fontSize="medium" />,
      hooks: "reports_main",
      active: "reports_main",
      // children: [
      //   {
      //     title: "Stock",
      //     hook: "stock",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Expense & Account",
      //     hook: "expense&account",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Contact & CRM",
      //     hook: "contact&crm",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Sales",
      //     hook: "sales",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Purchases",
      //     hook: "purchases",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Profit/Loss",
      //     hook: "profit/loss",
      //     tabs: ["main", "completed", "pending"],
      //   },
      //   {
      //     title: "Invoices",
      //     hook: "invoices",
      //     tabs: ["main", "completed", "pending"],
      //   },
      // ],
    },
    {
      title: "Account",
      icon: <AccountCircleRoundedIcon fontSize="medium" />,
      hooks: "account",
      active: "account",
      children: [
        {
          title: "Profile",
          hook: "profile",
          link: "/cloud-profile-account/client-account?page=company-profile&section=owner-profile",
        },
        {
          title: "Settings",
          hook: "setting",
          link: "/cloud-profile-account/client-account?page=setting&section=owner-profile",
        },
        {
          title: "Users",
          hook: "users",
          link: "/cloud-profile-account/client-account?page=access-control&section=owner-profile",
        },
        {
          title: "Language",
          hook: "language",
          link: "/cloud-profile-account/client-account?page=company-profile&section=owner-profile",
        },
      ],
    },
    {
      title: "Help & Support",
      icon: <HelpCenterRoundedIcon fontSize="medium" />,
      hooks: "support",
      active: "support",
      children: [
        { title: "FAQs", hook: "faqs" },
        {
          title: "Contact Support",
          hook: "contact-support",

        },
        {
          title: "System Guide",
          hook: "system-guide",

        },
      ],
    },
  ];

  const menuItems = allMenuItems.map(item => ({
    ...item,
    children: item.children?.filter(child => isCompanySectionAllowed(accessType, staffData, child.hook)).map(child => ({
      ...child,
      link: accessType === "USER_ACCESS" && child.hook === "users" ? undefined : child.link,
    })),
  })).filter(item => item.active === "support" ||
    (item.children ? item.children.length > 0 : isCompanySectionAllowed(accessType, staffData, item.hooks)));

  useEffect(() => {
    if (accessType !== "USER_ACCESS") return;
    if (!isCompanySectionAllowed(accessType, staffData, active_display || "dashboard")) {
      const first = menuItems[0];
      if (first) {
        const child = first.children?.[0];
        dispatch(Action.dispathcDashboardNavigator({ active: first.active, title: first.title }));
        if (child) dispatch(Action.dispatchDashboardSubNavigator({ hook: child.hook, title: child.title, main: first.title }));
      }
    }
  }, [accessType, staffData, active_display, dispatch]);

  useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]');

    if (meta) {
      meta.setAttribute("content", "#ededed");
    }
  }, []);

  function alertPaymentBill() {
    if (accessType === "CLIENT_ACCESS") setOpenModalBill(true);
  }
  useEffect(() => {
    if (subscriptionAccess.active || accessType !== "CLIENT_ACCESS" || !companyData?.clientId) return;
    const key = `universe-subscription-notified-${companyData.clientId}-${companyData.subscription?.expiryDate || "missing"}`;
    if (window.sessionStorage.getItem(key)) return;
    const timer = window.setTimeout(() => {
      window.sessionStorage.setItem(key, "1");
      setOpenModalBill(true);
    }, 1000);
    return () => window.clearTimeout(timer);
  }, [subscriptionAccess.active, accessType, companyData?.clientId, companyData?.subscription?.expiryDate]);

  const subscriptionBannerKey = `universe-subscription-banner-dismissed-${companyData?.clientId || "company"}-${companyData?.subscription?.expiryDate || "missing"}-${subscriptionAccess.state}`;
  const bannerDismissed = dismissedBannerKey === subscriptionBannerKey ||
    (typeof window !== "undefined" && window.sessionStorage.getItem(subscriptionBannerKey) === "1");
  const showSubscriptionBanner = !bannerDismissed &&
    (!subscriptionAccess.active || (subscriptionAccess.state === "expiring" && subscriptionAccess.remainingDays <= 3));
  const dismissSubscriptionBanner = () => {
    setDismissedBannerKey(subscriptionBannerKey);
    window.sessionStorage.setItem(subscriptionBannerKey, "1");
  };

  return (
    <section className="sectionclientProfile">
      {loading && <IsLoading />}
      {alert && <AlertBar alert={alert} setAlert={setAlert} />}
      {openModalBill && (
        <div className="universeSubscriptionBackdrop">
          {toggleModalBoxContents()}
        </div>
      )}

      <div className="clientProfileCont ">
        {isMobileNavOpen && (
          <ClientMobileNavigation
            companyData={companyData}
            staffData={staffData}
            accessType={accessType}
            menuItems={menuItems}
            active={active}
            activeDisplay={active_display}
            triggerRef={mobileMenuTriggerRef}
            onClose={closeMobileNavigation}
            onNavigate={(item, index) => handleNavigator(item, index, "DIRECT_BUTTON_ACTION")}
            onSubNavigate={handleMobileSubNavigator}
            onTerminal={apiFetchItems}
            hasPOSAccess={canOpenPOS(accessType, staffData)}
            onLogout={logOut}
          />
        )}
        <ComputerNavigationBar
          navigate={navigate}
          active_title={active_title}
          menuItems={menuItems}
          active={active}
          handleNavigator={handleNavigator}
          openIndex={openIndex}
          active_display={active_display}
          handleSubNavigator={handleSubNavigator}
        />
        <main className="companyAcctMain fx fx-cl">
          {active_display === "dashboard" && showSubscriptionBanner && (
            <div className="universeSubscriptionBanner" role="status">
              <span className="universeSubscriptionBannerText">
                {subscriptionAccess.active
                  ? `Your subscription expires in ${subscriptionAccess.remainingDays} day(s).`
                  : "Subscription access is paused. Your business records remain available."}
              </span>
              {accessType === "CLIENT_ACCESS" ? (
                <button type="button" className="universeSubscriptionBannerAction" onClick={alertPaymentBill}>
                  {subscriptionAccess.active ? "View plans" : "Renew subscription"}
                </button>
              ) : !subscriptionAccess.active ? <span>Contact your account owner</span> : null}
              <button type="button" className="universeSubscriptionBannerDismiss" aria-label="Dismiss subscription notice" title="Dismiss notice" onClick={dismissSubscriptionBanner}>×</button>
            </div>
          )}
          <ClientMobileTopbar
            triggerRef={mobileMenuTriggerRef}
            companyName={companyData?.businessProfile?.basicInfo?.businessName || "Universe Inventory"}
            pageTitle={active_display_title || active_title || "Dashboard"}
            onOpen={() => setIsMobileNavOpen(true)}
            onTerminal={apiFetchItems}
            hasPOSAccess={canOpenPOS(accessType, staffData)}
          />
          {active_display === "dashboard" && (
            <div className="clientHeader clientHeaderComputer fx-ac fx-jb">
              <div className="clientDpCont fx-ac fx-jc space1">
                <div className="fx-ac space1">
                  <figure className="clientDp fx-ac">
                    {(accessType === "USER_ACCESS" ? staffData?.files?.profilImage : companyData?.founder?.files?.profilImage) ? (
                      <img
                        src={accessType === "USER_ACCESS" ? staffData?.files?.profilImage : companyData?.founder?.files?.profilImage}
                        alt=""
                      />
                    ) : (
                      <span className="fs6 fw400">
                        {accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName?.slice(0, 1) : companyData?.founder?.firstName?.slice(0, 1)}
                      </span>
                    )}
                  </figure>
                  <p className="fx-cl spacem" style={{ fontSize: "1.6rem" }}>
                    <h3>
                      {companyData?.businessProfile?.basicInfo?.businessName}
                    </h3>
                    {accessType === "CLIENT_ACCESS" && (
                      <span className="date">
                        <strong>{companyData?.founder?.firstName}: </strong>{" "}
                        Founder
                      </span>
                    )}
                    {accessType === "USER_ACCESS" && (
                      <span className="date">
                        <strong>{staffData?.role?.name}: </strong>
                        {staffData?.personalInfo?.firstName}{" "}
                        {staffData?.personalInfo?.otherName}
                      </span>
                    )}
                  </p>
                </div>
              </div>
              <span className="clientDashboardHeadRight fx-ac fx-jc space1">
                {/* {hasFeature("sales.view") && ( */}
                {canOpenPOS(accessType, staffData) && <button
                  className="point_ofsales_btn  fx-ac spacem"
                  onClick={() => apiFetchItems()}
                >
                  <figure>
                    <DiscountIcon fontSize="large" />
                  </figure>
                  <span>Transaction Terminal</span>
                </button>}
                {/*  )} */}
                <button className="notifBtn clientDashboardHeadBtn fx-ac fx-jc space1">
                  <NotificationsActiveOutlinedIcon fontSize="medium" />
                  <figure>0</figure>
                </button>
                {/* Profile */}
                <span className="dropDownBtn fx-cl">
                  {" "}
                  <div className="fx-ac space">
                    {" "}
                    <div className="fx-ac">
                      {companyData?.founder?.files?.profilImage ? (
                        <img
                          src={companyData?.founder?.files?.profilImage}
                          alt=""
                          style={{
                            width: "3.2rem",
                            height: "3.2rem",
                            borderRadius: "99rem",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <span className="clientDashboardHeadBtn">
                          <PersonIcon fontSize="large" />
                        </span>
                      )}
                    </div>
                    {/* <div className="fx-cl spacem fs2 fw500">
                                  {" "}
                                  <span>
                                    {" "}
                                    <span className="fw500 fs2">
                                      {" "}
                                      {clientData?.founder?.firstName ||
                                        "Not provided"}{" "}
                                    </span>{" "}
                                  </span>{" "}
                                </div>{" "} */}
                  </div>{" "}
                  <div className="dropDownContent">
                    {accessType === "USER_ACCESS" ? (
                      <div className="profileDropdownAdvanced fx-cl space2 pd-nm">
                        <strong>{staffData?.personalInfo?.firstName || staffData?.userName}</strong>
                        <span>{staffData?.role?.name || "Team member"}</span>
                        <Link to="/clients/users/profile" className="profileTextButton">My personal profile</Link>
                        <Link to="/clients/users/workspace" className="profileTextButton">User workspace</Link>
                        <button type="button" className="profileTextButton" onClick={logOut}>Sign out</button>
                      </div>
                    ) : <ProfileDropContents
                      handleSubNavigator={handleSubNavigator}
                      setAlert={setAlert}
                      redirect={navigate}
                      clientData={companyData}
                      logOut={logOut}
                    />}
                  </div>
                </span>
              </span>
            </div>
          )}

          <div className="clientContents clientAccountScroll">
            {accessNotice && <div role="alert" className="pd3 fs2" onClick={() => setAccessNotice("")}>{accessNotice} (Click to dismiss)</div>}
                {switchComponents()}
          </div>
        </main>
      </div>
    </section>
  );
}

function ComputerNavigationBar({
  navigate,
  active_title,
  menuItems,
  active,
  handleNavigator,
  openIndex,
  active_display,
  handleSubNavigator,
}) {
  return (
    <div className="clientAsideSec computerNavigationBar fs2 cwb fx-cl fx-jb space5">
      <div
        className="fx-ac fx-jc"
        style={{
          width: "100%",
          fontSize: "1.4rem",
          fontWeight: "bold",
          cursor: "pointer",
        }}
        onClick={() => navigate("/")}
      >
        <figure className="dashboardLogo fx-ac space2 fx-jc">
          <img src={UniLogo} alt="" />
        </figure>
      </div>
      {/* <div>
          <span style={{ textTransform: "capitalize" }}>{active_title}</span>
        </div> */}
      <div className="fx-cl space2">
        <div className="clientProfileItemsCont flex1 fx-cl spacem">
          {menuItems?.map((item, index) => (
            <div className="fx-cl" key={index}>
              {item.children ? (
                <button
                  className={`clientDashboardNaV cb fx-ac fx-jb  ${
                    active === `${item.active}` ? "active-prl-tab" : null
                  }`}
                  onClick={() => {
                    handleNavigator(item, index);
                  }}
                >
                  <span className=" fx-ac spacem">
                    <span className="clientDashboardNaVIcon">
                      {item.icon}
                      {item.img}
                    </span>

                    <span>{item.title}</span>
                  </span>
                  {item?.children && (
                    <span className="clientProfileDropdownBtn fx-ac fx-jc">
                      {openIndex === index ? (
                        <KeyboardArrowDownIcon fontSize="small" />
                      ) : (
                        <KeyboardArrowRightIcon fontSize="small" />
                      )}
                    </span>
                  )}
                </button>
              ) : (
                <button
                  className={`clientDashboardNaV cb fx-ac fx-jb  ${
                    active === `${item.active}` ? "active-prl-tab" : null
                  }`}
                  onClick={() => {
                    handleNavigator(item, index);
                  }}
                >
                  <span className=" fx-ac spacem">
                    <span className="clientDashboardNaVIcon">
                      {item.icon}
                      {item.img}
                    </span>

                    <span>{item.title}</span>
                  </span>
                </button>
              )}

              {openIndex === index ? (
                <div
                  className={` ${
                    item?.children && "clientSubNavCont fx-cl spacem"
                  }`}
                >
                  {item?.children?.map((sub, idx) => (
                    <button
                      className={`clientDashboardSubMenu cb fx-ac space1  ${
                        active_display == `${sub.hook}` ||
                        (active_display == "item-explore-display" &&
                          sub.hook === "items") ||
                        (active_display == "add-new-item" &&
                          sub.hook === "items") ||
                        (active_display == "edit-item-display" &&
                          sub.hook === "items")
                          ? "active-prl-submenu"
                          : null
                      }`}
                      key={idx}
                      onClick={() => {
                        handleSubNavigator(
                          sub.hook,
                          sub.title,
                          item.title,
                          sub.link,
                        );
                      }}
                    >
                      <figure className="clientSubNavIcon fx-ac fx-jc">
                        <CheckIcon fontSize="small" />
                      </figure>

                      <span>{sub.title}</span>
                    </button>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
        </div>
        <figure>&nbsp;</figure>
      </div>
    </div>
  );
}
function ProfileDropContents({ setLoading, redirect, clientData, logOut, handleSubNavigator, setAlert }) {
  const businessName =
    clientData?.companyClient?.businessProfile?.basicInfo?.businessName ||
    clientData?.businessProfile?.basicInfo?.businessName ||
    "Your Business";

  const firstName =
    clientData?.founder?.firstName || clientData?.founder?.firstName || "";

  const lastName =
    clientData?.founder?.lastName ||
    clientData?.founder?.surname ||
    clientData?.founder?.lastName ||
    "";

  const profileImage =
    clientData?.founder?.files?.profilImage || clientData?.founder?.photo || "";

  const subscription =
    clientData?.companyClient?.subscription?.name ||
    clientData?.subscription?.name ||
    "Starter";

  const currentRank =
    clientData?.companyClient?.businessProfile?.businessRanking?.currentRank ||
    clientData?.businessProfile?.businessRanking?.currentRank ||
    "BRONZE";

  const progressPercentage =
    clientData?.companyClient?.businessProfile?.businessRanking
      ?.progressPercentage ||
    clientData?.businessProfile?.businessRanking?.progressPercentage ||
    0;

  const storageUsed =
    clientData?.companyClient?.storage?.usedMB ||
    clientData?.storage?.usedMB ||
    0;

  const storageLimit =
    clientData?.companyClient?.storage?.limitMB ||
    clientData?.storage?.limitMB ||
    1;

  const storagePercentage = Math.min(
    Math.round((storageUsed / storageLimit) * 100),
    100,
  );

  const statistics =
    clientData?.companyClient?.statistics || clientData?.statistics || {};

  const setupSteps = [
    {
      label: "Business profile",
      completed: Boolean(
        clientData?.companyClient?.businessProfile?.basicInfo?.businessName,
      ),
    },
    {
      label: "Branch setup",
      completed: Boolean(clientData?.companyDefaultBranch?.branchName),
    },
    {
      label: "Inventory setup",
      completed: Boolean(clientData?.companyDefaultInventory?.inventoryName),
    },
    {
      label: "Warehouse setup",
      completed: Boolean(clientData?.companyDefaultWarehouse?.warehouseName),
    },
    {
      label: "Bank account",
      completed:
        Array.isArray(clientData?.companyClient?.bank_accounts) &&
        clientData.companyClient.bank_accounts.length > 0,
    },
  ];

  const completedSetupSteps = setupSteps.filter(
    (step) => step.completed,
  ).length;

  const setupPercentage = Math.round(
    (completedSetupSteps / setupSteps.length) * 100,
  );

  const menuItemsPrimary = [
    {
      icon: <NotificationsNoneOutlinedIcon fontSize="large" />,
      title: "Notifications",
      description: "Alerts, stock warnings & activity",
      badge: "3",
      action: () => redirect("/cloud-profile-account/client-account?page=manage-notifications"),
    },
    {
      icon: <ShareIcon fontSize="large" />,
      title: "Messages",
      description: "Workspace conversations",
      badge: "2",
      action: () => setAlert({ type: "info", message: "Workspace messaging is not connected yet." }),
    },
    {
      icon: <DownloadOutlinedIcon fontSize="large" />,
      title: "Reports",
      description: "Business reports & analytics",
      action: () => handleSubNavigator("reports_main", "Reports", "Reports"),
    },
  ];

  const menuItemsManagement = [
    {
      icon: <BookmarksOutlinedIcon fontSize="large" />,
      title: "Bank Accounts",
      description: "Manage receiving accounts",
      action: () => setAlert({ type: "info", message: "Bank account management is not connected yet." }),
    },
    {
      icon: <PersonOutlineIcon fontSize="large" />,
      title: "Contacts",
      description: "Customers, suppliers & contacts",
      action: () => setAlert({ type: "info", message: "Contact management is not connected here yet. Use the dashboard Add Customer or Add Supplier action to create a contact." }),
    },
  ];

  return (
    <div className="profileDropdownAdvanced fx-cl">
      {/* ================================================================
          PROFILE HEADER
      ================================================================ */}
      <div className="profileAdvancedHeader fx-cl space2">
        <div className="fx-ac fx-jb">
          <div className="fx-ac space1">
            {profileImage ? (
              <div className="profileAdvancedAvatarWrap">
                <img
                  src={profileImage}
                  alt=""
                  className="profileAdvancedAvatar"
                />

                <span className="profileAdvancedOnlineDot" />
              </div>
            ) : (
              <span className="clientDashboardHeadBtn profileAdvancedAvatarFallback">
                <PersonIcon fontSize="large" />
              </span>
            )}

            <div className="fx-cl spacem">
              <div className="fx-ac fx-cl space">
                <span className="fs4 fw600 profileAdvancedName">
                  {firstName} {lastName}
                </span>

                <span className="profileVerifiedBadge">
                  <Profile />
                </span>
              </div>

              <span className="fs2 cb">Workspace Manager</span>

              <span className="fs1 profileAdvancedBusiness">
                {businessName}
              </span>
            </div>
          </div>

          <div className="profileRankBadge fx-cl fx-ac">
            <span className="profileRankBadgeLabel">RANK</span>

            <span className="profileRankBadgeValue">{currentRank}</span>
          </div>
        </div>

        {/* Subscription strip */}
        <div className="profileSubscriptionBar fx-ac fx-jb">
          <div className="fx-ac space">
            <span className="profileSubscriptionIcon fx-ac fx-jc">
              <AutoAwesomeOutlinedIcon />
            </span>

            <div className="fx-cl">
              <span className="fs1 cb">Current plan</span>

              <span className="fs2 fw600">{subscription}</span>
            </div>
          </div>

          <button
            type="button"
            className="profileUpgradeMiniBtn"
            onClick={() => redirect("/pricing")}
          >
            Upgrade
          </button>
        </div>
      </div>

      {/* ================================================================
          WORKSPACE LAUNCH
      ================================================================ */}
      <div className="profileWorkspaceCard fx-cl space2">
        <div className="fx-ac fx-jb">
          <div className="fx-ac space">
            <span className="profileWorkspaceIcon fx-ac fx-jc">
              <DashboardOutlinedIcon />
            </span>

            <div className="fx-cl">
              <span className="fs3 fw600">Inventory Workspace</span>

              <span className="fs1 cb">Manage your entire business</span>
            </div>
          </div>

          <span className="profileWorkspaceLive">LIVE</span>
        </div>

        <button
          type="button"
          className="profileWorkspaceLaunch"
          onClick={() => handleSubNavigator("dashboard", "Dashboard", "Dashboard")}
        >
          <span>Launch Inventory Workspace</span>

          <ArrowForwardIcon />
        </button>
      </div>

      {/* ================================================================
          BUSINESS SETUP PROGRESS
      ================================================================ */}
      <div className="profileSetupCard fx-cl space2">
        <div className="fx-ac fx-jb">
          <div className="fx-cl">
            <span className="fs3 fw600">Business setup</span>

            <span className="fs1 cb">
              Complete your workspace configuration
            </span>
          </div>

          <span className="profileSetupPercentage">{setupPercentage}%</span>
        </div>

        <div className="profileSetupProgress">
          <span
            style={{
              width: `${setupPercentage}%`,
            }}
          />
        </div>

        <div className="fx-ac fx-jb">
          <span className="fs1 cb">
            {completedSetupSteps} of {setupSteps.length} completed
          </span>

          <button
            type="button"
            className="profileSetupButton"
            onClick={() =>
              redirect("/cloud-profile-account/client-account?page=company-profile")
            }
          >
            Continue setup
          </button>
        </div>
      </div>

      {/* ================================================================
          STORAGE + BUSINESS STATS
      ================================================================ */}
      <div className="profileResourceCard fx-cl space2">
        <div className="fx-ac fx-jb">
          <div className="fx-ac space">
            <span className="profileResourceIcon">
              <CloudOutlinedIcon />
            </span>

            <div className="fx-cl">
              <span className="fs2 fw600">Workspace storage</span>

              <span className="fs1 cb">
                {storageUsed} MB of {storageLimit} MB used
              </span>
            </div>
          </div>

          <span className="fs2 fw600">{storagePercentage}%</span>
        </div>

        <div className="profileStorageProgress">
          <span
            style={{
              width: `${storagePercentage}%`,
            }}
          />
        </div>

        <div className="g g3 profileMiniStats">
          <div className="fx-cl fx-ac">
            <span className="fs4 fw600">{statistics.products || 0}</span>
            <span className="fs1 cb">Products</span>
          </div>

          <div className="fx-cl fx-ac">
            <span className="fs4 fw600">{statistics.customers || 0}</span>
            <span className="fs1 cb">Customers</span>
          </div>

          <div className="fx-cl fx-ac">
            <span className="fs4 fw600">{statistics.branches || 1}</span>
            <span className="fs1 cb">Branches</span>
          </div>
        </div>
      </div>

      {/* ================================================================
          BUSINESS GROWTH
      ================================================================ */}
      <div className="profileGrowthCard fx-ac fx-jb">
        <div className="fx-ac space">
          <span className="profileGrowthIcon fx-ac fx-jc">
            <TrendingUpIcon />
          </span>

          <div className="fx-cl">
            <span className="fs2 fw600">Business growth</span>

            <span className="fs1 cb">Progress toward your next rank</span>
          </div>
        </div>

        <div className="profileGrowthProgressWrap">
          <span className="fs1 fw600">{progressPercentage}%</span>

          <div className="profileGrowthProgress">
            <span
              style={{
                width: `${progressPercentage}%`,
              }}
            />
          </div>
        </div>
      </div>

      {/* ================================================================
          QUICK ACTIONS
      ================================================================ */}
      <div className="profileSectionLabel">
        <span>Workspace</span>
      </div>

      <div className="profileAdvancedMenu fx-cl">
        {menuItemsPrimary.map((item, index) => (
          <button
            type="button"
            className="profileAdvancedMenuItem fx-ac fx-jb"
            key={index}
            onClick={item.action}
          >
            <div className="fx-ac space1">
              <span className="profileMenuIcon fx-ac fx-jc">{item.icon}</span>

              <div className="fx-cl">
                <span className="fs2 fw500">{item.title}</span>

                <span className="fs1 cb">{item.description}</span>
              </div>
            </div>

            <div className="fx-ac space">
              {item.badge && (
                <span className="profileMenuBadge">{item.badge}</span>
              )}

              <ChevronRightIcon />
            </div>
          </button>
        ))}
      </div>

      {/* ================================================================
          MANAGEMENT
      ================================================================ */}
      <div className="profileSectionLabel">
        <span>Management</span>
      </div>

      <div className="profileAdvancedMenu fx-cl">
        {menuItemsManagement.map((item, index) => (
          <button
            type="button"
            className="profileAdvancedMenuItem fx-ac fx-jb"
            key={index}
            onClick={item.action}
          >
            <div className="fx-ac space1">
              <span className="profileMenuIcon fx-ac fx-jc">{item.icon}</span>

              <div className="fx-cl">
                <span className="fs2 fw500">{item.title}</span>

                <span className="fs1 cb">{item.description}</span>
              </div>
            </div>

            <ChevronRightIcon />
          </button>
        ))}
      </div>

      {/* ================================================================
          SETTINGS / SECURITY
      ================================================================ */}
      <div className="profileAdvancedBottom fx-cl">
        <button
          type="button"
          className="profileAdvancedMenuItem fx-ac fx-jb"
          onClick={() => redirect("/cloud-profile-account/client-account?page=company-profile&section=company-preferences")}
        >
          <div className="fx-ac space1">
            <span className="profileMenuIcon fx-ac fx-jc">
              <AutoAwesomeOutlinedIcon fontSize="large" />
            </span>

            <div className="fx-cl">
              <span className="fs2 fw500">Settings</span>

              <span className="fs1 cb">
                Workspace preferences & configuration
              </span>
            </div>
          </div>

          <ChevronRightIcon />
        </button>

        <button
          type="button"
          className="profileAdvancedMenuItem fx-ac fx-jb"
          onClick={() => redirect("/cloud-profile-account/client-account?page=access-control&section=security")}
        >
          <div className="fx-ac space1">
            <span className="profileMenuIcon fx-ac fx-jc">
              <SecurityOutlinedIcon fontSize="large" />
            </span>

            <div className="fx-cl">
              <span className="fs2 fw500">Security</span>

              <span className="fs1 cb">Password, authentication & access</span>
            </div>
          </div>

          <span className="profileSecurityStatus">Protected</span>
        </button>

        <button
          type="button"
          className="profileAdvancedLogout fx-ac space"
          onClick={() => logOut()}
        >
          <PowerSettingsNewOutlinedIcon fontSize="large" />

          <div className="fx-cl">
            <span className="fs2 fw600">Log Out</span>

            <span className="fs1">Securely end this session</span>
          </div>
        </button>
      </div>

      {/* ================================================================
          FOOTER
      ================================================================ */}
      <div className="profileAdvancedFooter fx-ac fx-jc">
        <LockOutlinedIcon />

        <span className="fs1">
          Your workspace is protected by Universe Inventory security.
        </span>
      </div>
    </div>
  );
}
